import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "../App.css";

const Layout = ({ children, navProps = {} }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { activeSection = "home", scrollToSection, refs = {} } = navProps;

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const navItems = [
    { name: "Home", path: "/", section: "home", ref: refs.home },
    { name: "Products", path: "/", section: "products", ref: refs.products },
    { name: "Solutions", path: "/", section: "solutions", ref: refs.solutions },
    {
      name: "Free Invoice Generator",
      path: "/invoice-generator",
      section: "invoice",
    },
    {
      name: "File Diff Checker",
      path: "/file-difference-checker",
      section: "diff-checker",
    },
    { name: "Features", path: "/", section: "features", ref: refs.features },
    { name: "Pricing", path: "/", section: "pricing", ref: refs.pricing },
    {
      name: "Testimonials",
      path: "/",
      section: "testimonials",
      ref: refs.testimonials,
    },
    { name: "Support", path: "/", section: "support", ref: refs.support },
    { name: "About", path: "/", section: "about", ref: refs.about },
    { name: "Contact", path: "/", section: "contact", ref: refs.contact },
  ];

  const handleNavClick = (item) => {
    if (item.ref && location.pathname === "/") {
      scrollToSection(item.ref, item.section);
    } else {
      navigate(item.path);
    }
    setIsNavOpen(false);
  };

  return (
    <div className="app">
      <nav className="navbar">
        <div className="navbar-content">
          <h1>Dhandha Karle</h1>
          <button className="hamburger" onClick={toggleNav}>
            <span className={`hamburger-line ${isNavOpen ? "open" : ""}`}></span>
            <span className={`hamburger-line ${isNavOpen ? "open" : ""}`}></span>
            <span className={`hamburger-line ${isNavOpen ? "open" : ""}`}></span>
          </button>
          <div className={`nav-links ${isNavOpen ? "open" : ""}`}>
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item)}
                className={`nav-link ${
                  (location.pathname === "/" && activeSection === item.section) ||
                  (location.pathname === item.path && item.path !== "/")
                    ? "active"
                    : ""
                }`}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {children}

      <footer className="footer" data-footer-id="layout-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Dhandha Karle</h3>
            <p className="footer-tagline">
              Simplifying Business Growth Across the Globe
            </p>
            <p>
              Empowering businesses worldwide with innovative POS, inventory, and
              invoice solutions since 2021.
            </p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>
              Email:{" "}
              <a href="mailto:support@dhandhakarle.com">
                support@dhandhakarle.com
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a
                href="https://instagram.com/dhandhakarle"
                target="_blank"
                rel="noreferrer"
                className="social-link instagram-link"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
                Instagram
              </a>
              <a
                href="https://www.linkedin.com/in/dhandhakarle/"
                target="_blank"
                rel="noreferrer"
                className="social-link linkedin-link"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-1.337-.027-3.063-1.867-3.063-1.872 0-2.158 1.462-2.158 2.971v5.696h-3v-11h2.883v1.496h.041c.402-.761 1.385-1.557 2.848-1.557 3.043 0 3.604 2.002 3.604 4.606v6.455z" />
                </svg>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Dhandha Karle. All Rights Reserved.
          </p>
          <div className="footer-extra">
            <a href="/privacy" className="footer-extra-link">
              Privacy Policy
            </a>
            <a href="/terms" className="footer-extra-link">
              Terms of Service
            </a>
            <a href="/invoice-generator" className="footer-extra-link">
              Free Invoice Generator
            </a>
             <a href="/refund-policy" className="footer-extra-link">
              Refund Policy
            </a>
          </div> 
        </div>
      </footer>
    </div>
  );
};

export default Layout;